module.exports = __webpack_public_path__ + "static/media/14UNEP8.8d3e0675.jpg";